import React from 'react';
import { SidebarToggleButtonProps } from 'types/components.types';

const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({ 
  onClick, 
  isCollapsed = false,
  className = '',
  'aria-label': ariaLabel = 'Toggle sidebar'
}) => {
  return (
    <button
      className={`p-1 text-gray-500 hover:bg-gray-50 rounded transition-colors ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`transition-transform duration-200 ${isCollapsed ? 'rotate-180' : ''}`}
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        <line x1="9" y1="3" x2="9" y2="21"/>
      </svg>
    </button>
  );
};

export default SidebarToggleButton;
